import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { Keyboard, Rocket } from "lucide-react";
import { Store } from "../../store";

// lazy load release info modal, shortcuts modal
const ReleaseInfoModal = React.lazy(() => import("../ReleaseInfoModal/ReleaseInfoModal"));
const ShortcutsModal = React.lazy(() => import("../ShortcutsModal/ShortcutsModal"));

const Header = ({ backHandler, title, actions, onClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    state: { viewportMode },
  } = useContext(Store);
  const isViewPortMode3d = viewportMode && viewportMode === "3d";
  const [showShortcuts, setShowShortcuts] = useState(false);
  const [showReleaseInfo, setShowReleaseInfo] = useState(false);

  const navigateToWarehoues = () => {
    navigate("/warehouses");
  };

  return (
    <div className="header">
      <div className="header-info">
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={onClick || navigateToWarehoues}
        >
          {backHandler}
        </div>
        <h3 className="title">{title}</h3>
      </div>

      <div className="actions">
        {isViewPortMode3d && (
          <div className="shortcuts-button">
            <button onClick={() => setShowShortcuts(true)} className="shortcut-btn" title="Keyboard shortcuts (?)">
              <Keyboard className="icon-sm" />
              <span className="shortcut-text">Shortcuts</span>
            </button>
          </div>
        )}
        {actions}
        <div className="release-info-button">
          <button
            onClick={() => setShowReleaseInfo(true)}
            className="shortcut-btn"
            title="What's New"
            style={{
              background: "linear-gradient(135deg, #6366f1 0%, #a855f7 100%)",
              color: "white",
              border: "none",
            }}
          >
            <Rocket className="icon-sm" />
            <span className="shortcut-text">What's New</span>
          </button>
        </div>
      </div>

      {showShortcuts && (
        <div
          className="configure-shelf-container"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#29292a32",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: "10",
          }}
        >
          <div
            className="configure-shelf-wrapper"
            style={{
              width: "95%",
              height: "90%",
            }}
          >
            <React.Suspense fallback={<div>Loading...</div>}>
              <ShortcutsModal isOpen={showShortcuts} onClose={() => setShowShortcuts(false)} />
            </React.Suspense>
          </div>
        </div>
      )}
      {showReleaseInfo && (
        <React.Suspense fallback={<div>Loading...</div>}>
          <ReleaseInfoModal isOpen={showReleaseInfo} onClose={() => setShowReleaseInfo(false)} />
        </React.Suspense>
      )}
    </div>
  );
};

export default Header;
